import { useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
import CMPWabsolute from "./images/logo.png";
import Liwei from "./images/LiWei.png";
import MichaelJohnson from "./images/MichaelJohnson.png";
import RajeshPatel from "./images/RajeshPatel.png";
import SophiaTan from "./images/SophiaTan.png";
import BlockTech from "./svg/BlockTech.svg";
import Bitstamp from "./svg/bitstamp.svg";
import Btcex from "./svg/btcex.svg";
import Coinex from "./svg/coinex.svg";
import Coinflex from "./svg/coinflex.svg";
import Coinlist from "./svg/coinlist.svg";
import Coinmetro from "./svg/coinmetro.svg";
import Coinsbit from "./svg/coinsbit.svg";
import Coinut from "./svg/coinut.svg";
import Ecash from "./svg/ecash.svg";

function App() {
  const [arbitrageList, setArbitrageList] = useState([]);
  // const getArbitrageList = async () => {
  //   const res = await axios.get("https://cmpw.io/api/arbitrage");
  //   if (res.data && res.data.data) {
  //     setArbitrageList(res.data.data);
  //   }
  // };
  useEffect(() => {
    //getArbitrageList();
    // Overall bot transaction status
    const pairs = ["BTC/USDT", "ETH/USDT", "BNB/USDT", "XRP/USDT", "TRX/USDT"];
    const exchanges = [
      "Bitget",
      "Binance",
      "Coinbase",
      "OKX",
      "XT.COM",
      "Phemex",
    ];
    const types = ["Transaction"];
    const profits = ["0.02%", "0.44%", "0.21%", "0.46%", "0.29%"];

    const dataContainer = document.getElementById("data-container");

    function getRandomData() {
      const pair = pairs[Math.floor(Math.random() * pairs.length)];
      const amount = (Math.random() * 100000).toFixed(3);
      const type = types[0];
      const buy = `Buy on ${
        exchanges[Math.floor(Math.random() * exchanges.length)]
      }`;
      let sell;
      do {
        sell = `Sell on ${
          exchanges[Math.floor(Math.random() * exchanges.length)]
        }`;
      } while (buy === sell);
      const profit = profits[Math.floor(Math.random() * profits.length)];
      const mxid = Math.random().toString(36).substring(2, 15);

      return {
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }),
        pair,
        amount,
        type,
        buy,
        sell,
        profit,
        mxid,
      };
    }

    function typeText(element, text, callback) {
      let charIndex = 0;

      function typeChar() {
        if (charIndex < text.length) {
          element.textContent += text[charIndex];
          charIndex++;
          setTimeout(typeChar, 7);
        } else if (callback) {
          callback();
        }
      }

      typeChar();
    }

    function addDataItem(item, immediate = false) {
      const dataItem = document.createElement("div");
      dataItem.className = "data-item";
      dataItem.innerHTML = `
                    <div class="time">${immediate ? item.time : ""}</div>
                    <div class="pair">${immediate ? item.pair : ""}</div>
                    <div class="amount">${immediate ? item.amount : ""}</div>
                    <div class="type">${immediate ? item.type : ""}</div>
                    <div class="buy">${immediate ? item.buy : ""}</div>
                    <div class="sell">${immediate ? item.sell : ""}</div>
                    <div class="profit">${immediate ? item.profit : ""}</div>
                    <div class="mxid">${immediate ? item.mxid : ""}</div>
                `;
      dataContainer.appendChild(dataItem);

      if (!immediate) {
        const fields = [
          item.time,
          item.pair,
          item.amount,
          item.type,
          item.buy,
          item.sell,
          item.profit,
          item.mxid,
        ];
        const fieldElements = dataItem.querySelectorAll("div");

        function typeNextField(index) {
          if (index < fields.length) {
            typeText(fieldElements[index], fields[index], () => {
              typeNextField(index + 1);
            });
          }
        }

        typeNextField(0);
      }
    }

    for (let i = 0; i < 5; i++) {
      addDataItem(getRandomData(), true);
    }

    const observerOptions = {
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const fadeIns = document.querySelectorAll(".fade-in");
    fadeIns.forEach((fadeIn) => {
      observer.observe(fadeIn);
    });

    const links = document.querySelectorAll(".header__nav-link");

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const targetClass = link.getAttribute("data-target");
        const targetElement = document.querySelector(targetClass);

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      });
    });

    const mobileMenuIcon = document.querySelector(".mobile-menu-icon");
    const mobileNav = document.querySelector(".mobile-nav");
    const mobileNavLinks = document.querySelectorAll(".mobile-nav__link");

    mobileMenuIcon.addEventListener("click", function () {
      mobileNav.classList.toggle("active");
    });

    mobileNavLinks.forEach((link) => {
      link.addEventListener("click", function () {
        mobileNav.classList.remove("active");
      });
    });

    document.addEventListener("click", function (event) {
      if (
        !mobileNav.contains(event.target) &&
        !mobileMenuIcon.contains(event.target)
      ) {
        mobileNav.classList.remove("active");
      }
    });

    const interval = setInterval(() => {
      if (dataContainer.childNodes.length > 5) {
        dataContainer.removeChild(dataContainer.firstChild);
      }
      addDataItem(getRandomData());
    }, 1000);
    if (window.TradingView) {
      new window.TradingView.widget({
        width: "100%",
        height: "600",
        symbol: "BINANCE:BTCUSDT",
        interval: "D",
        timezone: "Etc/UTC",
        theme: "dark",
        style: "1",
        locale: "en",
        toolbar_bg: "#f1f3f6",
        enable_publishing: false,
        allow_symbol_change: true,
        container_id: "tradingview_btc_chart",
      });
    }
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <header className="header">
        <div className="header__container">
          <svg
            className="mobile-menu-icon"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.66602 7H23.3327"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.66602 14H23.3327"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.66602 21H23.3327"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="mobile-nav">
            <ul className="mobile-nav__list">
              <li className="mobile-nav__item">
                <a
                  className="mobile-nav__link"
                  href="#"
                  data-target=".dashboard"
                >
                  Dashboard
                </a>
              </li>
              <li className="mobile-nav__item">
                <a
                  className="mobile-nav__link"
                  href="#"
                  data-target=".dashboard"
                >
                  Arbitrage
                </a>
              </li>
              <li className="mobile-nav__item">
                <a className="mobile-nav__link" href="#" data-target=".team">
                  Our Team
                </a>
              </li>
              <li
                className="mobile-nav__item"
                onClick={() => {
                  window.open(
                    "https://cmpw.gitbook.io/cmpw",
                    "_blank",
                    "noopener, noreferrer"
                  );
                }}
              >
                <a className="mobile-nav__link">White Paper</a>
              </li>
            </ul>
          </div>
          <div className="header__logo" style={{ paddingLeft: 20 }}>
            <a href="./index.html" className="header__logo-link">
              <img
                src={CMPWabsolute}
                alt="logo"
                className="header__logo-image"
                loading="lazy"
                style={{ width: "100%" }}
              />
            </a>
          </div>
          <nav className="header__nav">
            <ul className="header__nav-list">
              <li className="header__nav-item">
                <a
                  href="#"
                  className="header__nav-link"
                  data-target=".dashboard"
                >
                  Dashboard
                </a>
              </li>
              <li className="header__nav-item">
                <a
                  href="#"
                  className="header__nav-link"
                  data-target=".arbitrage"
                >
                  Arbitrage
                </a>
              </li>
              <li className="header__nav-item">
                <a href="#" className="header__nav-link" data-target=".team">
                  Our Team
                </a>
              </li>
              <li
                className="header__nav-item"
                onClick={() => {
                  window.open(
                    "https://cmpw.gitbook.io/cmpw",
                    "_blank",
                    "noopener, noreferrer"
                  );
                }}
              >
                <a className="header__nav-link">White Paper</a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <main className="main">
        <svg
          width="1920"
          height="2094"
          viewBox="0 0 1920 2094"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="trinity_svg"
        >
          <path
            opacity="0.0144928"
            d="M235.273 838.787C225.064 839.7 216.691 847.259 214.742 857.323L152.836 1176.99C151.684 1182.94 152.927 1189.11 156.296 1194.15L415.356 1581.62C418.005 1585.59 421.821 1588.63 426.275 1590.33L807.659 1735.88C815.735 1738.96 824.856 1737.26 831.272 1731.47L1042.04 1541.19C1048.45 1535.4 1051.08 1526.5 1048.84 1518.15L942.904 1123.92C941.667 1119.31 939.03 1115.21 935.358 1112.17L576.301 814.971C571.631 811.106 565.624 809.241 559.586 809.781L235.273 838.787Z"
            stroke="url(#paint0_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.0289855"
            d="M278.953 812.118C268.737 812.511 260.007 819.599 257.525 829.517L179.035 1143.12C177.561 1149.01 178.475 1155.24 181.578 1160.46L417.623 1557.39C420.067 1561.5 423.731 1564.75 428.106 1566.68L798.357 1730.07C806.255 1733.56 815.439 1732.32 822.141 1726.88L1041.26 1548.96C1047.96 1543.52 1051.05 1534.79 1049.26 1526.34L965.379 1130.43C964.388 1125.75 961.964 1121.5 958.443 1118.26L618.435 805.743C613.966 801.635 608.053 799.461 601.987 799.694L278.953 812.118Z"
            stroke="url(#paint1_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.0434783"
            d="M323.146 786.965C312.952 786.84 303.891 793.441 300.885 803.183L206.277 1109.86C204.485 1115.67 205.066 1121.95 207.893 1127.34L420.65 1532.39C422.88 1536.64 426.382 1540.08 430.666 1542.24L788.97 1722.71C796.669 1726.59 805.891 1725.83 812.859 1720.76L1039.63 1555.54C1046.6 1550.47 1050.14 1541.92 1048.81 1533.4L986.85 1137.03C986.109 1132.29 983.905 1127.9 980.547 1124.48L660.2 797.806C655.943 793.465 650.141 790.986 644.061 790.911L323.146 786.965Z"
            stroke="url(#paint2_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.057971"
            d="M367.767 763.341C357.62 762.701 348.256 768.799 344.739 778.339L234.521 1077.28C232.415 1082.99 232.66 1089.3 235.203 1094.84L424.474 1506.67C426.483 1511.05 429.813 1514.68 433.994 1517.06L779.585 1713.81C787.068 1718.07 796.302 1717.79 803.517 1713.09L1037.21 1560.89C1044.42 1556.2 1048.41 1547.86 1047.54 1539.3L1007.32 1143.66C1006.83 1138.87 1004.86 1134.36 1001.67 1130.76L701.528 791.127C697.496 786.565 691.819 783.787 685.742 783.404L367.767 763.341Z"
            stroke="url(#paint3_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.0724638"
            d="M412.722 741.255C402.649 740.104 393.01 745.686 388.994 754.996L263.717 1045.4C261.302 1051 261.209 1057.33 263.459 1063L429.125 1480.28C430.906 1484.77 434.052 1488.58 438.119 1491.18L770.284 1703.38C777.53 1708.01 786.752 1708.21 794.193 1703.9L1034.07 1564.99C1041.51 1560.68 1045.92 1552.58 1045.52 1543.99L1026.79 1150.27C1026.56 1145.45 1024.82 1140.83 1021.82 1137.05L742.348 785.674C738.552 780.901 733.016 777.831 726.957 777.139L412.722 741.255Z"
            stroke="url(#paint4_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.0869565"
            d="M478.045 707.612C468.071 705.958 458.186 711.011 453.686 720.064L313.94 1001.2C311.222 1006.66 310.79 1012.99 312.74 1018.78L454.753 1440.17C456.3 1444.76 459.254 1448.74 463.196 1451.55L781.271 1678.34C788.262 1683.33 797.448 1684 805.093 1680.1L1050.41 1554.7C1058.05 1550.79 1062.88 1542.95 1062.94 1534.36L1065.39 1143.72C1065.42 1138.88 1063.92 1134.15 1061.11 1130.21L802.717 768.31C799.168 763.339 793.787 759.984 787.762 758.985L478.045 707.612Z"
            stroke="url(#paint5_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.101449"
            d="M523.419 688.605C513.57 686.454 503.468 690.967 498.499 699.739L344.911 970.881C341.896 976.204 341.125 982.508 342.77 988.4L461.158 1412.58C462.464 1417.26 465.217 1421.41 469.023 1424.42L772.398 1664.92C779.117 1670.25 788.241 1671.39 796.069 1667.9L1046.07 1556.19C1053.9 1552.69 1059.13 1545.13 1059.65 1536.57L1082.9 1150.14C1083.2 1145.29 1081.95 1140.47 1079.33 1136.38L842.342 765.187C839.05 760.032 833.84 756.399 827.864 755.094L523.419 688.605Z"
            stroke="url(#paint6_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.115942"
            d="M568.867 671.132C559.168 668.493 548.879 672.458 543.459 680.924L376.688 941.405C373.385 946.565 372.276 952.83 373.609 958.81L468.474 1384.47C469.534 1389.23 472.078 1393.53 475.737 1396.74L763.856 1650.04C770.286 1655.69 779.323 1657.3 787.312 1654.23L1041.25 1556.37C1049.24 1553.29 1054.85 1546.03 1055.83 1537.52L1099.45 1156.38C1100.01 1151.54 1099.01 1146.65 1096.6 1142.41L881.276 763.168C878.251 757.84 873.225 753.939 867.313 752.331L568.867 671.132Z"
            stroke="url(#paint7_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.130435"
            d="M614.31 655.184C604.785 652.067 594.339 655.477 588.486 663.612L409.226 912.804C405.642 917.785 404.198 923.992 405.214 930.044L476.729 1355.9C477.538 1360.72 479.864 1365.16 483.367 1368.57L755.726 1633.73C761.852 1639.69 770.779 1641.77 778.906 1639.12L1036.01 1555.2C1044.14 1552.55 1050.13 1545.61 1051.55 1537.18L1115.05 1162.4C1115.87 1157.58 1115.13 1152.63 1112.94 1148.26L919.468 762.204C916.718 756.718 911.89 752.558 906.058 750.65L614.31 655.184Z"
            stroke="url(#paint8_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.144928"
            d="M679.773 627.643C670.446 624.06 659.873 626.908 653.608 634.691L462.58 872.006C458.726 876.794 456.948 882.926 457.644 889.032L506.051 1313.82C506.606 1318.69 508.706 1323.26 512.042 1326.85L768.196 1602.93C774.002 1609.19 782.796 1611.72 791.038 1609.5L1050.56 1539.59C1058.8 1537.37 1065.14 1530.77 1067.02 1522.44L1149.84 1155.06C1150.92 1150.27 1150.44 1145.27 1148.48 1140.77L976.974 749.145C974.508 743.515 969.892 739.106 964.154 736.902L679.773 627.643Z"
            stroke="url(#paint9_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.15942"
            d="M724.951 614.688C715.845 610.65 705.175 612.933 698.519 620.343L496.472 845.24C492.358 849.819 490.251 855.857 490.624 862.003L516.233 1284.47C516.531 1289.38 518.397 1294.07 521.558 1297.85L761.113 1583.88C766.586 1590.42 775.223 1593.39 783.558 1591.61L1044.74 1535.73C1053.07 1533.95 1059.74 1527.7 1062.06 1519.5L1163.62 1160.49C1164.96 1155.75 1164.74 1150.71 1163 1146.11L1013.52 750.138C1011.35 744.378 1006.95 739.73 1001.33 737.235L724.951 614.688Z"
            stroke="url(#paint10_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.173913"
            d="M769.877 603.199C761.015 598.721 750.279 600.436 743.253 607.452L530.961 819.434C526.598 823.792 524.166 829.718 524.213 835.885L527.402 1254.83C527.439 1259.77 529.066 1264.56 532.041 1268.51L754.664 1563.53C759.789 1570.32 768.247 1573.73 776.651 1572.39L1038.74 1530.52C1047.14 1529.18 1054.12 1523.31 1056.87 1515.26L1176.51 1165.56C1178.11 1160.89 1178.16 1155.82 1176.66 1151.12L1049.18 752.03C1047.3 746.156 1043.15 741.281 1037.64 738.5L769.877 603.199Z"
            stroke="url(#paint11_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.188406"
            d="M814.473 593.141C805.875 588.237 795.104 589.384 787.731 595.987L565.989 794.606C561.388 798.727 558.638 804.526 558.358 810.696L539.565 1224.94C539.341 1229.89 540.722 1234.78 543.503 1238.88L748.912 1541.91C753.679 1548.95 761.936 1552.78 770.385 1551.88L1032.63 1523.97C1041.08 1523.07 1048.35 1517.58 1051.53 1509.7L1188.55 1170.23C1190.41 1165.63 1190.73 1160.56 1189.46 1155.76L1083.9 754.76C1082.33 748.786 1078.42 743.697 1073.05 740.636L814.473 593.141Z"
            stroke="url(#paint12_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.202899"
            d="M858.657 584.485C850.345 579.171 839.569 579.75 831.874 585.924L601.494 770.777C596.668 774.649 593.606 780.302 592.999 786.459L552.727 1194.85C552.239 1199.8 553.369 1204.78 555.948 1209.03L743.919 1519.09C748.316 1526.34 756.35 1530.59 764.82 1530.13L1026.49 1516.07C1034.96 1515.62 1042.5 1510.54 1046.09 1502.85L1199.76 1174.44C1201.87 1169.94 1202.46 1164.87 1201.44 1160L1117.64 758.271C1116.38 752.214 1112.73 746.922 1107.52 743.589L858.657 584.485Z"
            stroke="url(#paint13_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.217391"
            d="M922.473 564.098C914.466 558.39 903.715 558.404 895.723 564.133L657.533 734.866C652.496 738.477 649.129 743.967 648.196 750.094L587.005 1151.54C586.253 1156.48 587.127 1161.52 589.496 1165.92L759.859 1482.01C763.877 1489.47 771.667 1494.11 780.136 1494.1L1040.51 1493.76C1048.98 1493.74 1056.75 1489.08 1060.75 1481.61L1230.28 1165.08C1232.64 1160.67 1233.5 1155.63 1232.74 1150.69L1170.49 749.406C1169.54 743.282 1166.16 737.8 1161.11 734.203L922.473 564.098Z"
            stroke="url(#paint14_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.231884"
            d="M965.625 558.133C957.942 552.049 947.247 551.503 938.983 556.772L693.826 713.08C688.592 716.418 684.929 721.73 683.669 727.809L602.176 1121.25C601.16 1126.16 601.774 1131.26 603.925 1135.79L756.567 1456.93C760.196 1464.57 767.722 1469.6 776.166 1470.03L1034.52 1483.23C1042.97 1483.66 1050.97 1479.42 1055.36 1472.2L1239.93 1168.28C1242.53 1164 1243.66 1158.98 1243.15 1154L1202.18 754.298C1201.55 748.123 1198.44 742.465 1193.58 738.611L965.625 558.133Z"
            stroke="url(#paint15_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.246377"
            d="M1008.16 553.445C1000.82 547.005 990.208 545.904 981.7 550.699L730.428 692.328C725.011 695.381 721.061 700.499 719.478 706.513L618.352 1090.93C617.072 1095.8 617.422 1100.95 619.349 1105.6L754.209 1430.82C757.442 1438.61 764.685 1444.01 773.08 1444.88L1028.73 1471.41C1037.12 1472.28 1045.32 1468.49 1050.08 1461.52L1248.85 1170.92C1251.69 1166.77 1253.09 1161.8 1252.84 1156.78L1232.8 759.782C1232.49 753.571 1229.67 747.752 1225 743.651L1008.16 553.445Z"
            stroke="url(#paint16_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.26087"
            d="M1050.01 549.992C1043.02 543.213 1032.53 541.565 1023.8 545.877L767.273 672.619C761.688 675.378 757.461 680.285 755.559 686.218L635.518 1060.65C633.976 1065.46 634.06 1070.64 635.756 1075.4L752.826 1403.72C755.656 1411.66 762.599 1417.41 770.922 1418.72L1023.17 1458.33C1031.5 1459.64 1039.87 1456.29 1045 1449.6L1257.07 1172.97C1260.14 1168.96 1261.81 1164.05 1261.81 1159L1262.32 765.797C1262.33 759.567 1259.81 753.601 1255.34 749.262L1050.01 549.992Z"
            stroke="url(#paint17_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.275362"
            d="M1091.12 547.719C1084.5 540.623 1074.15 538.437 1065.24 542.254L804.317 653.952C798.58 656.408 794.087 661.09 791.869 666.924L653.68 1030.46C651.878 1035.2 651.693 1040.4 653.152 1045.25L752.48 1375.72C754.901 1383.77 761.525 1389.86 769.754 1391.6L1017.95 1444.02C1026.18 1445.75 1034.7 1442.86 1040.17 1436.47L1264.63 1174.38C1267.93 1170.53 1269.87 1165.7 1270.13 1160.64L1290.73 772.274C1291.06 766.042 1288.85 759.943 1284.59 755.377L1091.12 547.719Z"
            stroke="url(#paint18_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.289855"
            d="M1131.42 546.573C1125.19 539.18 1115.01 536.466 1105.93 539.781L841.49 636.329C835.618 638.473 830.871 642.915 828.343 648.633L672.813 1000.4C670.756 1005.06 670.299 1010.26 671.516 1015.2L753.198 1346.87C755.205 1355.02 761.495 1361.43 769.607 1363.59L1013.1 1428.49C1021.21 1430.65 1029.86 1428.22 1035.66 1422.15L1271.58 1175.14C1275.09 1171.46 1277.29 1166.72 1277.82 1161.66L1318.01 779.147C1318.66 772.93 1316.75 766.714 1312.73 761.931L1131.42 546.573Z"
            stroke="url(#paint19_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.304348"
            d="M1170.86 546.5C1165.04 538.832 1155.05 535.603 1145.84 538.408L878.737 619.747C872.746 621.572 867.757 625.761 864.925 631.347L692.905 970.544C690.594 975.1 689.866 980.297 690.836 985.313L755.018 1317.24C756.609 1325.47 762.548 1332.18 770.521 1334.76L1008.7 1411.8C1016.67 1414.38 1025.41 1412.42 1031.52 1406.68L1277.94 1175.22C1281.66 1171.72 1284.12 1167.08 1284.91 1162.04L1344.13 786.353C1345.11 780.166 1343.52 773.849 1339.73 768.862L1170.86 546.5Z"
            stroke="url(#paint20_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.318841"
            d="M1229.51 534.339C1224.1 526.419 1214.34 522.688 1205.02 524.978L936.117 591.099C930.024 592.597 924.807 596.519 921.676 601.957L734.052 927.83C731.493 932.275 730.493 937.449 731.211 942.528L778.089 1273.81C779.261 1282.09 784.836 1289.08 792.648 1292.07L1024.9 1380.87C1032.72 1383.86 1041.53 1382.37 1047.93 1376.98L1303.87 1161.49C1307.79 1158.18 1310.5 1153.66 1311.56 1148.64L1389.21 780.722C1390.51 774.582 1389.24 768.18 1385.7 762.999L1229.51 534.339Z"
            stroke="url(#paint21_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.333333"
            d="M1267.09 536.227C1262.1 528.076 1252.6 523.858 1243.21 525.631L973.356 576.571C967.179 577.737 961.748 581.381 958.327 586.654L756.017 898.509C753.214 902.83 751.942 907.968 752.406 913.098L782.222 1242.83C782.974 1251.15 788.171 1258.4 795.801 1261.79L1021.57 1361.95C1029.2 1365.33 1038.06 1364.32 1044.73 1359.3L1309.2 1160.12C1313.31 1157.02 1316.27 1152.63 1317.59 1147.65L1413.03 788.384C1414.64 782.308 1413.7 775.837 1410.42 770.475L1267.09 536.227Z"
            stroke="url(#paint22_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.347826"
            d="M1303.67 539.001C1299.12 530.642 1289.88 525.953 1280.45 527.206L1010.5 563.052C1004.25 563.881 998.624 567.234 994.921 572.328L778.874 869.53C775.832 873.714 774.29 878.801 774.496 883.97L787.538 1211.3C787.87 1219.62 792.677 1227.12 800.105 1230.89L1018.83 1341.97C1026.26 1345.75 1035.15 1345.21 1042.06 1340.56L1314.06 1158C1318.36 1155.12 1321.56 1150.87 1323.14 1145.95L1435.67 796.172C1437.6 790.177 1436.99 783.653 1433.97 778.123L1303.67 539.001Z"
            stroke="url(#paint23_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.362319"
            d="M1339.22 542.597C1335.11 534.055 1326.17 528.912 1316.72 529.645L1047.5 550.53C1041.21 551.018 1035.4 554.069 1031.42 558.968L802.613 840.944C799.339 844.978 797.528 850.001 797.474 855.195L794.074 1179.27C793.987 1187.59 798.393 1195.3 805.599 1199.45L1016.77 1321C1023.97 1325.14 1032.86 1325.08 1040 1320.83L1318.52 1155.11C1322.99 1152.45 1326.42 1148.37 1328.27 1143.51L1457.17 804.025C1459.41 798.126 1459.12 791.566 1456.39 785.881L1339.22 542.597Z"
            stroke="url(#paint24_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.376812"
            d="M1373.7 546.946C1370.03 538.244 1361.42 532.667 1351.98 532.882L1084.31 538.982C1077.99 539.126 1072.01 541.865 1067.77 546.556L827.194 812.794C823.696 816.665 821.618 821.61 821.301 826.817L801.832 1146.83C801.329 1155.11 805.324 1163.02 812.289 1167.53L1015.41 1299.06C1022.37 1303.57 1031.23 1303.98 1038.58 1300.13L1322.61 1151.43C1327.23 1149.02 1330.9 1145.1 1333 1140.32L1477.5 811.871C1480.05 806.085 1480.1 799.505 1477.64 793.679L1373.7 546.946Z"
            stroke="url(#paint25_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.391304"
            d="M1407.08 551.982C1403.86 543.143 1395.59 537.151 1386.19 536.851L1120.88 528.39C1114.55 528.188 1108.42 530.606 1103.93 535.073L852.596 785.122C848.881 788.818 846.54 793.672 845.96 798.88L810.835 1114.04C809.917 1122.27 813.494 1130.36 820.198 1135.21L1014.81 1276.21C1021.51 1281.07 1030.31 1281.95 1037.84 1278.52L1326.38 1146.96C1331.15 1144.79 1335.03 1141.05 1337.39 1136.37L1496.7 819.648C1499.54 813.989 1499.93 807.407 1497.77 801.454L1407.08 551.982Z"
            stroke="url(#paint26_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.405797"
            d="M1439.33 557.63C1436.57 548.68 1428.67 542.294 1419.34 541.484L1157.16 518.726C1150.84 518.177 1144.57 520.265 1139.84 524.496L878.784 757.969C874.86 761.478 872.259 766.226 871.414 771.422L821.083 1080.98C819.758 1089.13 822.907 1097.37 829.335 1102.56L1015 1252.51C1021.43 1257.7 1030.15 1259.05 1037.84 1256.04L1329.87 1141.67C1334.77 1139.76 1338.87 1136.21 1341.47 1131.64L1514.77 827.287C1517.91 821.772 1518.63 815.205 1516.76 809.139L1439.33 557.63Z"
            stroke="url(#paint27_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.42029"
            d="M1470.43 563.828C1468.13 554.79 1460.61 548.032 1451.37 546.718L1193.1 509.971C1186.81 509.075 1180.42 510.826 1175.46 514.807L905.719 731.379C901.596 734.69 898.739 739.32 897.63 744.49L832.579 1047.73C830.85 1055.79 833.566 1064.16 839.7 1069.66L1016.03 1228.01C1022.16 1233.52 1030.78 1235.33 1038.6 1232.74L1333.13 1135.58C1338.15 1133.92 1342.44 1130.58 1345.29 1126.13L1531.72 834.733C1535.14 829.376 1536.2 822.84 1534.64 816.677L1470.43 563.828Z"
            stroke="url(#paint28_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.434783"
            d="M1500.36 570.501C1498.52 561.399 1491.4 554.292 1482.29 552.483L1228.66 502.093C1222.41 500.851 1215.92 502.258 1210.75 505.977L933.366 705.387C929.053 708.488 925.946 712.986 924.573 718.118L845.321 1014.35C843.195 1022.29 845.474 1030.77 851.298 1036.58L1017.92 1202.77C1023.75 1208.58 1032.23 1210.83 1040.17 1208.69L1336.19 1128.65C1341.32 1127.27 1345.81 1124.15 1348.9 1119.83L1547.58 841.92C1551.28 836.737 1552.67 830.248 1551.41 824.002L1500.36 570.501Z"
            stroke="url(#paint29_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.449275"
            d="M1529.11 577.577C1527.74 568.436 1521.03 561.004 1512.08 558.708L1263.79 495.062C1257.61 493.477 1251.04 494.533 1245.67 497.979L961.695 680.028C957.202 682.909 953.85 687.262 952.215 692.343L859.311 980.921C856.796 988.732 858.633 997.291 864.132 1003.38L1020.72 1176.83C1026.22 1182.92 1034.55 1185.62 1042.57 1183.92L1339.12 1120.91C1344.34 1119.8 1349.01 1116.91 1352.33 1112.73L1562.38 848.788C1566.35 843.793 1568.07 837.369 1567.12 831.056L1529.11 577.577Z"
            stroke="url(#paint30_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.463768"
            d="M1556.67 584.984C1555.77 575.828 1549.49 568.095 1540.71 565.325L1298.46 488.844C1292.36 486.918 1285.73 487.62 1280.17 490.781L990.657 655.333C985.994 657.983 982.405 662.179 980.508 667.195L874.53 947.512C871.635 955.17 873.029 963.789 878.189 970.144L1024.44 1150.27C1029.6 1156.62 1037.75 1159.75 1045.84 1158.49L1341.94 1112.33C1347.24 1111.51 1352.09 1108.86 1355.64 1104.84L1576.13 855.278C1580.37 850.484 1582.41 844.143 1581.78 837.777L1556.67 584.984Z"
            stroke="url(#paint31_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.478261"
            d="M1583.04 592.653C1582.59 583.505 1576.76 575.496 1568.19 572.264L1332.63 483.407C1326.63 481.144 1319.96 481.488 1314.22 484.354L1020.21 631.334C1015.39 633.744 1011.57 637.77 1009.42 642.709L890.968 914.194C887.702 921.679 888.65 930.335 893.459 936.935L1029.11 1123.13C1033.92 1129.73 1041.87 1133.28 1049.99 1132.47L1344.72 1102.94C1350.08 1102.4 1355.08 1100 1358.85 1096.15L1588.88 861.336C1593.36 856.757 1595.73 850.513 1595.42 844.11L1583.04 592.653Z"
            stroke="url(#paint32_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.492754"
            d="M1608.22 600.513C1608.22 591.397 1602.84 583.139 1594.5 579.458L1366.26 478.715C1360.38 476.121 1353.69 476.103 1347.8 478.665L1050.32 608.059C1045.36 610.219 1041.31 614.063 1038.9 618.913L908.612 881.037C904.986 888.332 905.489 897 909.935 903.826L1034.75 1095.48C1039.2 1102.3 1046.92 1106.27 1055.06 1105.9L1347.48 1092.72C1352.89 1092.48 1358.05 1090.33 1362.03 1086.66L1600.65 866.908C1605.38 862.557 1608.07 856.427 1608.07 850.003L1608.22 600.513Z"
            stroke="url(#paint33_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.507246"
            d="M1632.19 608.495C1632.65 599.435 1627.74 590.953 1619.65 586.839L1399.31 474.732C1393.57 471.813 1386.87 471.432 1380.84 473.681L1080.94 585.535C1075.84 587.437 1071.58 591.087 1068.91 595.835L927.428 848.109C923.453 855.196 923.513 863.854 927.585 870.886L1041.37 1067.38C1045.45 1074.41 1052.93 1078.77 1061.05 1078.85L1350.28 1081.7C1355.72 1081.75 1361.01 1079.87 1365.19 1076.39L1611.48 871.945C1616.43 867.833 1619.44 861.834 1619.76 855.405L1632.19 608.495Z"
            stroke="url(#paint34_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.521739"
            d="M1675.09 603.427C1676 594.445 1671.56 585.766 1663.75 581.236L1451.87 458.314C1446.29 455.077 1439.61 454.332 1433.45 456.261L1132.12 550.68C1126.9 552.316 1122.43 555.76 1119.52 560.393L967.511 802.371C963.2 809.233 962.818 817.858 966.507 825.074L1069.11 1025.78C1072.79 1033 1080.01 1037.74 1088.1 1038.26L1373.26 1056.76C1378.72 1057.12 1384.13 1055.51 1388.51 1052.24L1641.52 863.292C1646.69 859.432 1650 853.578 1650.64 847.159L1675.09 603.427Z"
            stroke="url(#paint35_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.536232"
            d="M1696.71 611.442C1698.05 602.561 1694.1 593.713 1686.59 588.785L1483.69 455.625C1478.29 452.078 1471.64 450.969 1465.37 452.571L1163.62 529.718C1158.29 531.08 1153.62 534.307 1150.47 538.813L988.611 770.09C983.976 776.712 983.158 785.28 986.455 792.66L1077.74 996.957C1081.03 1004.34 1087.96 1009.44 1095.99 1010.41L1376.25 1044.14C1381.71 1044.8 1387.23 1043.48 1391.8 1040.42L1650.59 867.106C1655.96 863.509 1659.57 857.817 1660.54 851.424L1696.71 611.442Z"
            stroke="url(#paint36_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.550725"
            d="M1717.17 619.375C1718.94 610.616 1715.48 601.626 1708.29 596.319L1514.85 453.523C1509.64 449.675 1503.05 448.204 1496.69 449.472L1195.48 509.564C1190.06 510.646 1185.2 513.646 1181.81 518.013L1010.8 738.226C1005.86 744.592 1004.61 753.082 1007.51 760.604L1087.38 967.862C1090.28 975.383 1096.9 980.838 1104.84 982.24L1379.4 1030.74C1384.85 1031.7 1390.46 1030.67 1395.21 1027.83L1658.85 870.244C1664.41 866.92 1668.31 861.405 1669.59 855.054L1717.17 619.375Z"
            stroke="url(#paint37_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.565217"
            d="M1736.49 627.157C1738.68 618.542 1735.71 609.437 1728.86 603.772L1545.33 451.962C1540.33 447.824 1533.81 445.993 1527.38 446.921L1227.66 490.232C1222.16 491.027 1217.13 493.788 1213.51 498.005L1034.05 706.836C1028.81 712.933 1027.14 721.321 1029.63 728.963L1098.04 938.553C1100.53 946.195 1106.83 951.98 1114.66 953.812L1382.76 1016.57C1388.17 1017.84 1393.86 1017.1 1398.77 1014.5L1666.34 872.662C1672.07 869.621 1676.26 864.296 1677.86 858.003L1736.49 627.157Z"
            stroke="url(#paint38_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.57971"
            d="M1754.69 634.729C1757.29 626.278 1754.81 617.086 1748.32 611.084L1575.11 450.905C1570.33 446.487 1563.91 444.299 1557.43 444.884L1260.12 471.736C1254.55 472.239 1249.36 474.753 1245.51 478.807L1058.32 675.981C1052.8 681.794 1050.71 690.06 1052.79 697.799L1109.71 909.096C1111.79 916.835 1117.75 922.931 1125.45 925.185L1386.34 1001.66C1391.71 1003.24 1397.46 1002.8 1402.53 1000.44L1673.1 874.326C1679 871.577 1683.46 866.458 1685.37 860.237L1754.69 634.729Z"
            stroke="url(#paint39_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.594203"
            d="M1771.8 642.024C1774.8 633.757 1772.82 624.507 1766.7 618.189L1604.17 450.301C1599.63 445.615 1593.32 443.075 1586.8 443.314L1292.8 454.081C1287.18 454.287 1281.83 456.544 1277.76 460.425L1083.57 645.708C1077.78 651.225 1075.28 659.346 1076.95 667.161L1122.39 879.543C1124.06 887.357 1129.67 893.744 1137.2 896.412L1390.21 986.024C1395.51 987.901 1401.31 987.772 1406.52 985.661L1679.2 875.196C1685.24 872.748 1689.96 867.847 1692.19 861.716L1771.8 642.024Z"
            stroke="url(#paint40_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.608696"
            d="M1787.84 648.988C1791.22 640.925 1789.74 631.643 1784.01 625.035L1632.49 450.112C1628.21 445.171 1622.03 442.285 1615.49 442.175L1325.65 437.279C1320 437.184 1314.51 439.174 1310.23 442.871L1109.74 616.074C1103.71 621.282 1100.81 629.24 1102.06 637.107L1136.06 849.958C1137.32 857.825 1142.56 864.482 1149.91 867.553L1394.38 969.681C1399.59 971.861 1405.43 972.042 1410.77 970.19L1684.67 875.247C1690.84 873.106 1695.82 868.439 1698.35 862.41L1787.84 648.988Z"
            stroke="url(#paint41_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.623188"
            d="M1802.85 655.561C1806.61 647.72 1805.62 638.433 1800.3 631.558L1660.06 450.289C1656.05 445.107 1650.02 441.881 1643.49 441.42L1358.63 421.328C1352.96 420.928 1347.34 422.645 1342.85 426.147L1136.8 587.122C1130.54 592.011 1127.25 599.784 1128.09 607.681L1150.73 820.393C1151.57 828.291 1156.43 835.195 1163.57 838.658L1398.89 952.655C1404.01 955.135 1409.87 955.63 1415.33 954.045L1689.58 874.446C1695.87 872.619 1701.08 868.196 1703.91 862.287L1802.85 655.561Z"
            stroke="url(#paint42_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.637681"
            d="M1816.87 661.687C1820.98 654.086 1820.49 644.822 1815.59 637.704L1686.88 450.787C1683.15 445.379 1677.3 441.82 1670.78 441.008L1391.7 406.231C1386.02 405.523 1380.28 406.958 1375.6 410.254L1164.7 558.896C1158.23 563.457 1154.56 571.025 1154.99 578.93L1166.38 790.904C1166.8 798.809 1171.26 805.94 1178.18 809.781L1403.8 934.97C1408.8 937.747 1414.66 938.558 1420.23 937.246L1693.98 872.767C1700.37 871.261 1705.81 867.095 1708.94 861.319L1816.87 661.687Z"
            stroke="url(#paint43_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.652174"
            d="M1829.93 667.317C1834.38 659.972 1834.37 650.757 1829.9 643.423L1712.92 451.563C1709.5 445.943 1703.83 442.061 1697.35 440.898L1424.79 391.985C1419.12 390.968 1413.28 392.113 1408.41 395.195L1193.38 531.439C1186.72 535.663 1182.68 543.008 1182.69 550.898L1182.97 761.546C1182.98 769.436 1187.04 776.771 1193.71 780.976L1409.1 916.654C1413.97 919.723 1419.82 920.853 1425.48 919.821L1697.91 870.191C1704.39 869.011 1710.05 865.113 1713.46 859.484L1829.93 667.317Z"
            stroke="url(#paint44_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.666667"
            d="M1842.08 672.403C1846.85 665.328 1847.32 656.189 1843.29 648.665L1738.2 452.573C1735.09 446.758 1729.62 442.561 1723.2 441.049L1457.86 378.587C1452.22 377.26 1446.29 378.109 1441.25 380.966L1222.8 504.79C1215.96 508.668 1211.57 515.772 1211.17 523.625L1200.51 732.372C1200.11 740.226 1203.74 747.74 1210.16 752.295L1414.85 897.736C1419.57 901.091 1425.39 902.541 1431.13 901.795L1701.45 866.699C1708 865.85 1713.86 862.231 1717.55 856.764L1842.08 672.403Z"
            stroke="url(#paint45_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.681159"
            d="M1853.34 676.894C1858.43 670.106 1859.37 661.069 1855.78 653.38L1762.7 453.77C1759.91 447.776 1754.67 443.276 1748.32 441.417L1490.87 366.028C1485.27 364.39 1479.26 364.938 1474.06 367.561L1252.89 478.979C1245.89 482.505 1241.17 489.352 1240.36 497.146L1218.95 703.431C1218.14 711.225 1221.36 718.895 1227.48 723.783L1421.06 878.241C1425.62 881.878 1431.39 883.648 1437.2 883.193L1704.65 862.275C1711.24 861.759 1717.29 858.431 1721.26 853.139L1853.34 676.894Z"
            stroke="url(#paint46_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.695652"
            d="M1863.78 680.75C1869.16 674.261 1870.56 665.35 1867.43 657.525L1786.43 455.109C1783.97 448.955 1778.97 444.162 1772.72 441.96L1523.76 354.298C1518.23 352.349 1512.16 352.589 1506.79 354.97L1283.6 454.039C1276.46 457.207 1271.42 463.779 1270.2 471.493L1238.28 674.77C1237.07 682.484 1239.86 690.286 1245.68 695.489L1427.77 858.202C1432.14 862.112 1437.85 864.202 1443.72 864.043L1707.55 856.907C1714.18 856.728 1720.41 853.698 1724.64 848.595L1863.78 680.75Z"
            stroke="url(#paint47_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.710145"
            d="M1873.45 683.928C1879.1 677.752 1880.95 668.992 1878.28 661.058L1809.39 456.547C1807.27 450.25 1802.53 445.177 1796.39 442.637L1556.51 343.384C1551.05 341.125 1544.93 341.054 1539.42 343.184L1314.87 429.995C1307.61 432.8 1302.26 439.084 1300.66 446.695L1258.48 646.437C1256.87 654.049 1259.22 661.957 1264.72 667.457L1435 837.648C1439.18 841.825 1444.8 844.233 1450.71 844.374L1710.24 850.587C1716.88 850.746 1723.27 848.024 1727.75 843.122L1873.45 683.928Z"
            stroke="url(#paint48_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.724638"
            d="M1882.38 686.397C1888.28 680.544 1890.57 671.959 1888.36 663.943L1831.58 458.045C1829.81 451.623 1825.34 446.285 1819.33 443.411L1589.04 333.274C1583.67 330.708 1577.52 330.32 1571.88 332.192L1346.63 406.875C1339.28 409.314 1333.64 415.294 1331.65 422.782L1279.49 618.478C1277.49 625.967 1279.4 633.957 1284.57 639.734L1442.76 816.617C1446.72 821.051 1452.25 823.776 1458.18 824.221L1712.74 843.314C1719.38 843.812 1725.91 841.406 1730.65 836.718L1882.38 686.397Z"
            stroke="url(#paint49_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.73913"
            d="M1890.63 688.116C1896.78 682.598 1899.49 674.21 1897.74 666.139L1853.01 459.553C1851.6 453.026 1847.42 447.436 1841.56 444.235L1621.34 323.945C1616.08 321.074 1609.91 320.367 1604.14 321.973L1378.85 384.691C1371.41 386.761 1365.51 392.424 1363.14 399.77L1301.3 590.93C1298.93 598.275 1300.39 606.323 1305.21 612.356L1451.09 795.135C1454.83 799.816 1460.24 802.855 1466.18 803.606L1715.14 835.08C1721.76 835.917 1728.42 833.834 1733.39 829.371L1890.63 688.116Z"
            stroke="url(#paint50_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.753623"
            d="M1898.26 689.063C1904.62 683.888 1907.74 675.719 1906.46 667.622L1873.7 461.038C1872.65 454.427 1868.77 448.6 1863.08 445.079L1653.34 315.384C1648.21 312.212 1642.04 311.182 1636.16 312.516L1411.44 363.467C1403.95 365.167 1397.79 370.501 1395.05 377.683L1323.87 563.839C1321.12 571.021 1322.15 579.1 1326.6 585.369L1460 773.245C1463.49 778.162 1468.77 781.512 1474.71 782.571L1717.47 825.894C1724.06 827.07 1730.84 825.317 1736.03 821.091L1898.26 689.063Z"
            stroke="url(#paint51_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.768116"
            d="M1905.32 689.205C1911.87 684.381 1915.39 676.452 1914.57 668.355L1893.65 462.453C1892.97 455.776 1889.41 449.729 1883.9 445.897L1685.01 307.563C1680.03 304.095 1673.87 302.74 1667.89 303.795L1444.36 343.207C1436.82 344.537 1430.43 349.532 1427.33 356.531L1347.16 537.235C1344.05 544.234 1344.63 552.319 1348.71 558.802L1469.5 750.973C1472.73 756.116 1477.86 759.772 1483.78 761.141L1719.81 815.755C1726.35 817.268 1733.22 815.85 1738.63 811.872L1905.32 689.205Z"
            stroke="url(#paint52_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.782609"
            d="M1911.86 688.521C1918.59 684.056 1922.48 676.387 1922.12 668.317L1912.87 463.763C1912.57 457.041 1909.34 450.79 1904.03 446.656L1716.32 300.461C1711.49 296.701 1705.37 295.02 1699.3 295.79L1477.53 323.925C1469.97 324.884 1463.37 329.529 1459.92 336.327L1371.13 511.156C1367.67 517.953 1367.81 526.02 1371.5 532.693L1479.61 728.359C1482.57 733.716 1487.54 737.672 1493.42 739.353L1722.2 804.676C1728.67 806.523 1735.62 805.445 1741.23 801.725L1911.86 688.521Z"
            stroke="url(#paint53_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.797101"
            d="M1917.93 686.992C1924.82 682.891 1929.07 675.5 1929.16 667.485L1931.39 464.928C1931.46 458.183 1928.57 451.745 1923.48 447.319L1747.22 294.051C1742.57 290.005 1736.49 287.996 1730.34 288.477L1510.9 305.622C1503.33 306.213 1496.54 310.5 1492.75 317.078L1395.74 485.631C1391.95 492.209 1391.65 500.232 1394.94 507.073L1490.34 705.439C1493.01 710.996 1497.8 715.247 1503.64 717.239L1724.7 792.667C1731.09 794.845 1738.1 794.111 1743.9 790.659L1917.93 686.992Z"
            stroke="url(#paint54_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.811594"
            d="M1923.61 684.6C1930.63 680.867 1935.22 673.772 1935.76 665.838L1949.22 465.91C1949.68 459.162 1947.14 452.557 1942.28 447.85L1777.69 288.302C1773.23 283.977 1767.2 281.641 1760.99 281.827L1544.41 288.298C1536.85 288.523 1529.89 292.444 1525.79 298.786L1420.95 460.688C1416.84 467.03 1416.11 474.984 1419 481.968L1501.71 682.246C1504.08 687.989 1508.67 692.529 1514.45 694.83L1727.37 779.74C1733.65 782.245 1740.72 781.859 1746.69 778.683L1923.61 684.6Z"
            stroke="url(#paint55_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.826087"
            d="M1928.93 681.335C1936.07 677.973 1940.98 671.19 1941.96 663.363L1966.38 466.676C1967.22 459.948 1965.04 453.193 1960.44 448.218L1807.67 283.187C1803.42 278.591 1797.47 275.928 1791.21 275.815L1577.99 271.952C1570.47 271.816 1563.36 275.364 1558.94 281.454L1446.71 436.354C1442.3 442.444 1441.15 450.306 1443.62 457.408L1513.71 658.819C1515.77 664.735 1520.15 669.555 1525.84 672.166L1730.25 765.918C1736.41 768.745 1743.51 768.708 1749.64 765.818L1928.93 681.335Z"
            stroke="url(#paint56_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.84058"
            d="M1933.97 677.188C1941.2 674.2 1946.41 667.744 1947.81 660.05L1982.9 467.195C1984.11 460.507 1982.31 453.624 1977.97 448.392L1837.15 278.675C1833.12 273.816 1827.27 270.828 1820.97 270.412L1611.58 256.58C1604.12 256.086 1596.88 259.257 1592.17 265.079L1472.99 412.654C1468.29 418.476 1466.71 426.222 1468.77 433.418L1526.36 635.197C1528.1 641.268 1532.25 646.361 1537.85 649.279L1733.4 751.221C1739.43 754.364 1746.54 754.678 1752.82 752.081L1933.97 677.188Z"
            stroke="url(#paint57_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.855072"
            d="M1938.78 672.156C1946.08 669.542 1951.57 663.427 1953.38 655.889L1998.79 467.435C2000.39 460.809 1998.96 453.816 1994.9 448.343L1866.09 274.733C1862.3 269.62 1856.55 266.308 1850.23 265.586L1645.14 242.169C1637.74 241.325 1630.4 244.113 1625.42 249.653L1499.74 389.607C1494.76 395.147 1492.78 402.753 1494.41 410.017L1539.67 611.415C1541.06 617.626 1544.97 622.982 1550.46 626.205L1736.87 735.674C1742.75 739.125 1749.86 739.792 1756.27 737.495L1938.78 672.156Z"
            stroke="url(#paint58_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.869565"
            d="M1943.4 666.23C1950.75 663.991 1956.5 658.229 1958.72 650.872L2014.09 467.361C2016.06 460.819 2015.02 453.737 2011.25 448.036L1894.46 271.32C1890.92 265.964 1885.31 262.331 1878.97 261.3L1678.6 228.703C1671.29 227.514 1663.85 229.918 1658.62 235.163L1526.91 367.225C1521.67 372.47 1519.29 379.913 1520.5 387.22L1553.62 587.505C1554.67 593.84 1558.32 599.448 1563.68 602.974L1740.71 719.298C1746.42 723.051 1753.5 724.07 1760.04 722.079L1943.4 666.23Z"
            stroke="url(#paint59_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.884058"
            d="M1947.91 659.419C1955.29 657.553 1961.28 652.154 1963.88 645.001L2028.81 466.95C2031.16 460.513 2030.52 453.365 2027.05 447.451L1922.25 268.407C1918.98 262.818 1913.5 258.867 1907.17 257.525L1711.9 216.17C1704.7 214.644 1697.19 216.662 1691.72 221.599L1554.45 345.528C1548.98 350.465 1546.21 357.723 1546.99 365.048L1568.23 563.51C1568.92 569.949 1572.3 575.8 1577.52 579.624L1744.95 702.129C1750.48 706.175 1757.53 707.544 1764.17 705.865L1947.91 659.419Z"
            stroke="url(#paint60_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.898551"
            d="M1952.36 651.724C1959.75 650.228 1965.94 645.202 1968.92 638.273L2042.99 466.172C2045.71 459.861 2045.46 452.667 2042.32 446.558L1949.42 265.95C1946.43 260.14 1941.11 255.875 1934.79 254.22L1744.99 204.545C1737.91 202.69 1730.36 204.322 1724.67 208.94L1582.32 324.522C1576.64 329.14 1573.49 336.191 1573.85 343.508L1583.5 539.46C1583.82 545.986 1586.9 552.067 1591.97 556.186L1749.66 684.192C1754.99 688.522 1761.98 690.241 1768.71 688.879L1952.36 651.724Z"
            stroke="url(#paint61_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.913043"
            d="M1956.79 643.157C1964.17 642.028 1970.55 637.382 1973.89 630.7L2056.66 465.007C2059.74 458.845 2059.89 451.627 2057.08 445.339L1975.95 263.917C1973.26 257.898 1968.11 253.323 1961.82 251.355L1777.82 193.809C1770.87 191.635 1763.3 192.882 1757.41 197.171L1610.48 304.219C1604.59 308.508 1601.09 315.332 1601.03 322.615L1599.4 515.395C1599.35 521.989 1602.13 528.289 1607.03 532.696L1754.85 665.529C1759.98 670.133 1766.89 672.198 1773.7 671.157L1956.79 643.157Z"
            stroke="url(#paint62_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.927536"
            d="M1961.27 633.727C1968.62 632.959 1975.16 628.701 1978.84 622.284L2069.84 463.429C2073.27 457.436 2073.83 450.217 2071.36 443.768L2001.82 262.264C1999.44 256.049 1994.49 251.17 1988.24 248.887L1810.33 183.933C1803.53 181.449 1795.96 182.313 1789.89 186.265L1638.87 284.621C1632.81 288.572 1628.95 295.149 1628.48 302.373L1615.95 491.348C1615.51 497.989 1617.97 504.495 1622.69 509.186L1760.58 646.17C1765.48 651.037 1772.31 653.445 1779.18 652.728L1961.27 633.727Z"
            stroke="url(#paint63_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.942029"
            d="M1965.84 623.452C1973.15 623.04 1979.82 619.174 1983.82 613.041L2082.56 461.422C2086.34 455.619 2087.3 448.422 2085.18 441.829L2027.03 260.955C2024.97 254.558 2020.22 249.38 2014.02 246.783L1842.48 174.89C1835.84 172.109 1828.29 172.593 1822.06 176.199L1667.45 265.734C1661.23 269.34 1657.05 275.651 1656.16 282.79L1633.13 467.356C1632.3 474.024 1634.43 480.722 1638.95 485.69L1766.89 626.158C1771.55 631.278 1778.27 634.024 1785.18 633.634L1965.84 623.452Z"
            stroke="url(#paint64_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.956522"
            d="M1970.56 612.348C1977.8 612.285 1984.59 608.815 1988.88 602.982L2094.86 458.965C2098.98 453.372 2100.35 446.22 2098.59 439.503L2051.54 259.944C2049.82 253.38 2045.29 247.91 2039.16 244.999L1874.22 166.646C1867.76 163.579 1860.25 163.688 1853.88 166.941L1696.18 247.554C1689.82 250.808 1685.33 256.836 1684.03 263.866L1650.94 443.45C1649.71 450.123 1651.49 456.999 1655.81 462.237L1773.8 605.531C1778.21 610.891 1784.81 613.971 1791.75 613.91L1970.56 612.348Z"
            stroke="url(#paint65_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.971014"
            d="M1975.47 600.435C1982.63 600.712 1989.51 597.639 1994.08 592.122L2106.77 456.039C2111.22 450.677 2112.99 443.592 2111.6 436.771L2075.36 259.19C2073.99 252.474 2069.69 246.719 2063.64 243.494L1905.5 159.164C1899.24 155.823 1891.78 155.563 1885.3 158.46L1725.01 230.076C1718.53 232.972 1713.75 238.7 1712.06 245.596L1669.36 419.661C1667.73 426.318 1669.15 433.356 1673.24 438.858L1781.34 584.329C1785.5 589.917 1791.96 593.324 1798.91 593.593L1975.47 600.435Z"
            stroke="url(#paint66_linear_62_12)"
            strokeWidth="4"
          />
          <path
            opacity="0.985507"
            d="M1980.63 587.738C1987.68 588.347 1994.62 585.671 1999.45 580.485L2118.32 452.636C2123.08 447.523 2125.25 440.529 2124.23 433.622L2098.46 258.653C2097.45 251.801 2093.41 245.769 2087.45 242.231L1936.28 152.41C1930.22 148.809 1922.84 148.187 1916.26 150.722L1753.89 213.296C1747.31 215.831 1742.26 221.244 1740.18 227.982L1688.38 396.023C1686.34 402.642 1687.39 409.827 1691.24 415.584L1789.55 562.599C1793.44 568.402 1799.74 572.128 1806.7 572.729L1980.63 587.738Z"
            stroke="url(#paint67_linear_62_12)"
            strokeWidth="4"
          />
          <path
            d="M1986.07 574.284C1993.01 575.215 1999.99 572.935 2005.04 568.092L2129.55 448.74C2134.6 443.896 2137.17 437.015 2136.54 430.044L2120.85 258.289C2120.21 251.318 2116.44 245.017 2110.59 241.169L1966.53 146.345C1960.68 142.496 1953.4 141.52 1946.74 143.692L1782.79 197.204C1776.13 199.375 1770.83 204.459 1768.38 211.015L1707.99 372.568C1705.54 379.124 1706.21 386.44 1709.8 392.444L1798.46 540.385C1802.06 546.389 1808.19 550.427 1815.13 551.358L1986.07 574.284Z"
            stroke="url(#paint68_linear_62_12)"
            strokeWidth="4"
          />
          <defs>
            <linearGradient
              id="paint0_linear_62_12"
              x1="216.356"
              y1="838.471"
              x2="1004.06"
              y2="1710.99"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_62_12"
              x1="260.138"
              y1="810.84"
              x2="994.558"
              y2="1715.34"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_62_12"
              x1="304.484"
              y1="784.735"
              x2="984.45"
              y2="1718.04"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_62_12"
              x1="349.305"
              y1="760.172"
              x2="973.832"
              y2="1719.09"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_62_12"
              x1="394.509"
              y1="737.162"
              x2="962.795"
              y2="1718.48"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_62_12"
              x1="460.127"
              y1="702.613"
              x2="971.554"
              y2="1703.09"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_62_12"
              x1="505.842"
              y1="682.719"
              x2="959.975"
              y2="1699.12"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_62_12"
              x1="551.675"
              y1="664.382"
              x2="948.261"
              y2="1693.47"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_62_12"
              x1="597.545"
              y1="647.594"
              x2="936.51"
              y2="1686.17"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_62_12"
              x1="663.478"
              y1="619.24"
              x2="944.925"
              y2="1664.11"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_62_12"
              x1="709.164"
              y1="605.5"
              x2="933.371"
              y2="1653.52"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_62_12"
              x1="754.637"
              y1="593.257"
              x2="922.051"
              y2="1641.33"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_62_12"
              x1="799.816"
              y1="582.478"
              x2="911.049"
              y2="1627.56"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_62_12"
              x1="844.617"
              y1="573.135"
              x2="900.447"
              y2="1612.25"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_62_12"
              x1="909.082"
              y1="552.097"
              x2="910.438"
              y2="1582.33"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_62_12"
              x1="952.914"
              y1="545.518"
              x2="900.879"
              y2="1564.05"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_62_12"
              x1="996.156"
              y1="540.255"
              x2="891.958"
              y2="1544.35"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint17_linear_62_12"
              x1="1038.74"
              y1="536.267"
              x2="883.739"
              y2="1523.28"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint18_linear_62_12"
              x1="1080.6"
              y1="533.5"
              x2="876.304"
              y2="1500.9"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint19_linear_62_12"
              x1="1121.68"
              y1="531.902"
              x2="869.706"
              y2="1477.26"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint20_linear_62_12"
              x1="1161.92"
              y1="531.422"
              x2="864.007"
              y2="1452.43"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint21_linear_62_12"
              x1="1221.38"
              y1="518.896"
              x2="879.378"
              y2="1413.36"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint22_linear_62_12"
              x1="1259.79"
              y1="520.464"
              x2="875.655"
              y2="1386.32"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint23_linear_62_12"
              x1="1297.21"
              y1="522.963"
              x2="872.982"
              y2="1358.27"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint24_linear_62_12"
              x1="1333.61"
              y1="526.329"
              x2="871.421"
              y2="1329.3"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint25_linear_62_12"
              x1="1368.94"
              y1="530.495"
              x2="870.999"
              y2="1299.47"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint26_linear_62_12"
              x1="1403.17"
              y1="535.392"
              x2="871.76"
              y2="1268.85"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint27_linear_62_12"
              x1="1436.28"
              y1="540.948"
              x2="873.731"
              y2="1237.52"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint28_linear_62_12"
              x1="1468.24"
              y1="547.098"
              x2="876.936"
              y2="1205.55"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint29_linear_62_12"
              x1="1499.03"
              y1="553.768"
              x2="881.398"
              y2="1173.03"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint30_linear_62_12"
              x1="1528.63"
              y1="560.887"
              x2="887.14"
              y2="1140.02"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint31_linear_62_12"
              x1="1557.04"
              y1="568.381"
              x2="894.168"
              y2="1106.61"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint32_linear_62_12"
              x1="1584.23"
              y1="576.179"
              x2="902.49"
              y2="1072.87"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint33_linear_62_12"
              x1="1610.23"
              y1="584.211"
              x2="912.118"
              y2="1038.88"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint34_linear_62_12"
              x1="1635"
              y1="592.407"
              x2="923.035"
              y2="1004.71"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint35_linear_62_12"
              x1="1678.69"
              y1="587.593"
              x2="955.359"
              y2="957.35"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint36_linear_62_12"
              x1="1701.08"
              y1="595.902"
              x2="968.858"
              y2="923.063"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint37_linear_62_12"
              x1="1722.28"
              y1="604.166"
              x2="983.624"
              y2="888.827"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint38_linear_62_12"
              x1="1742.33"
              y1="612.315"
              x2="999.645"
              y2="854.708"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint39_linear_62_12"
              x1="1761.22"
              y1="620.289"
              x2="1016.89"
              y2="820.783"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint40_linear_62_12"
              x1="1779"
              y1="628.02"
              x2="1035.34"
              y2="787.114"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint41_linear_62_12"
              x1="1795.69"
              y1="635.453"
              x2="1054.96"
              y2="753.771"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint42_linear_62_12"
              x1="1811.31"
              y1="642.523"
              x2="1075.73"
              y2="720.815"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint43_linear_62_12"
              x1="1825.91"
              y1="649.176"
              x2="1097.6"
              y2="688.306"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint44_linear_62_12"
              x1="1839.52"
              y1="655.358"
              x2="1120.53"
              y2="656.304"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint45_linear_62_12"
              x1="1852.18"
              y1="661.019"
              x2="1144.49"
              y2="624.864"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint46_linear_62_12"
              x1="1863.93"
              y1="666.109"
              x2="1169.42"
              y2="594.037"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint47_linear_62_12"
              x1="1874.81"
              y1="670.583"
              x2="1195.28"
              y2="563.872"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint48_linear_62_12"
              x1="1884.88"
              y1="674.397"
              x2="1222.01"
              y2="534.412"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint49_linear_62_12"
              x1="1894.18"
              y1="677.518"
              x2="1249.57"
              y2="505.705"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint50_linear_62_12"
              x1="1902.77"
              y1="679.903"
              x2="1277.91"
              y2="477.782"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint51_linear_62_12"
              x1="1910.69"
              y1="681.527"
              x2="1306.96"
              y2="450.686"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint52_linear_62_12"
              x1="1918"
              y1="682.355"
              x2="1336.66"
              y2="424.44"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint53_linear_62_12"
              x1="1924.75"
              y1="682.364"
              x2="1366.96"
              y2="399.076"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint54_linear_62_12"
              x1="1931.01"
              y1="681.533"
              x2="1397.79"
              y2="374.616"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint55_linear_62_12"
              x1="1936.82"
              y1="679.84"
              x2="1429.11"
              y2="351.076"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint56_linear_62_12"
              x1="1942.24"
              y1="677.275"
              x2="1460.83"
              y2="328.477"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint57_linear_62_12"
              x1="1947.34"
              y1="673.826"
              x2="1492.91"
              y2="306.83"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint58_linear_62_12"
              x1="1952.16"
              y1="669.487"
              x2="1525.29"
              y2="286.143"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint59_linear_62_12"
              x1="1956.77"
              y1="664.248"
              x2="1557.89"
              y2="266.415"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint60_linear_62_12"
              x1="1961.23"
              y1="658.116"
              x2="1590.67"
              y2="247.654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint61_linear_62_12"
              x1="1965.58"
              y1="651.088"
              x2="1623.55"
              y2="229.849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint62_linear_62_12"
              x1="1969.89"
              y1="643.177"
              x2="1656.48"
              y2="212.999"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint63_linear_62_12"
              x1="1974.21"
              y1="634.387"
              x2="1689.41"
              y2="197.091"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint64_linear_62_12"
              x1="1978.59"
              y1="624.737"
              x2="1722.26"
              y2="182.112"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint65_linear_62_12"
              x1="1983.08"
              y1="614.239"
              x2="1754.99"
              y2="168.044"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint66_linear_62_12"
              x1="1987.74"
              y1="602.912"
              x2="1787.55"
              y2="154.864"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint67_linear_62_12"
              x1="1992.61"
              y1="590.779"
              x2="1819.87"
              y2="142.549"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
            <linearGradient
              id="paint68_linear_62_12"
              x1="1997.74"
              y1="577.867"
              x2="1851.91"
              y2="131.074"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF1CF7" />
              <stop offset="1" stopColor="#00F0FF" />
            </linearGradient>
          </defs>
        </svg>
        <section className="intro fade-in">
          <h2 className="intro__title">Leveraged Blockchain Stocks</h2>
          <h2 className="intro__subtitle">LBS</h2>
          <p className="intro__text">
            Unlock the power of cross-platform trading and capitalize on price
            <br />
            discrepancies with our comprehensive guide to cryptocurrency
            arbitrage.
          </p>
          <a
            href="/api/file/apk"
            download="cmpw-app.apk"
            className="intro__link"
          >
            App Down
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <rect width="24" height="24" fill="url(#pattern0_65_359)" />
              <defs>
                <pattern
                  id="pattern0_65_359"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_65_359"
                    transform="scale(0.00195312)"
                  />
                </pattern>
                <image
                  id="image0_65_359"
                  width="512"
                  height="512"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </a>
        </section>
        <section className="dashboard fade-in">
          <h2 className="dashboard__title">Dashboard</h2>
          <div className="dashboard__intro">
            Introducing Staking - the arbitrage staking process with our
            exclusive Profit-Sharingx Model.
            <br />
            Deposit BTC or USDT to earn up to 0.68% daily returns. Start earning
            passive income today!
            <br />
            <b>Earn Up To 0.62% Optimized Daily Returns Starting Today!</b>
          </div>
          <ul className="dashboard__stats">
            <li className="dashboard__stat">
              <h3 className="dashboard__stat-title">Staking Volume</h3>
              <h2 className="dashboard__stat-value">
                {`$ ${arbitrageList
                  .find((itm) => itm.type === "staking")
                  ?.total_volume.toLocaleString()}`}
              </h2>
            </li>
            <li className="dashboard__stat">
              <h3 className="dashboard__stat-title">Trading Volume</h3>
              <h2 className="dashboard__stat-value">
                {`$ ${arbitrageList
                  .find((itm) => itm.type === "trading")
                  ?.total_volume.toLocaleString()}`}
              </h2>
            </li>
            <li className="dashboard__stat">
              <h3 className="dashboard__stat-title">Total Revenue</h3>
              <h2 className="dashboard__stat-value">
                {`$ ${arbitrageList
                  .find((itm) => itm.type === "revenue")
                  ?.total_volume.toLocaleString()}`}
              </h2>
            </li>
          </ul>
        </section>

        <section className="tradingview fade-in">
          <div className="tradingview__widget-container">
            <div
              id="tradingview_btc_chart"
              className="tradingview__chart"
            ></div>
          </div>
        </section>

        <section className="transaction fade-in">
          <h2 className="transaction__title">Overall bot transaction status</h2>
          <ul
            className="transaction__list data-container"
            id="data-container"
          ></ul>
        </section>

        <section className="leverage fade-in">
          <h2 className="leverage__title">
            Leveraging Multi-Platform
            <br />
            Opportunities
          </h2>
          <div className="leverage__content">
            <div className="leverage__item">
              <h3 className="leverage__item-title">
                Diverse Exchange
                <br />
                Ecosystem
              </h3>
              <p className="leverage__item-text">
                The cryptocurrency market is home to a diverse array of
                exchanges, each with its own unique features, trading pairs, and
                liquidity. By monitoring price differences across these
                platforms, savvy traders can identify and capitalize on
                arbitrage opportunities.
              </p>
            </div>

            <div className="leverage__item">
              <h3 className="leverage__item-title">
                Streamlined
                <br />
                Integration
              </h3>
              <p className="leverage__item-text">
                Leveraging advanced API integrations, you can seamlessly connect
                to multiple exchanges, enabling real-time data tracking and
                lightning-fast trade execution. This optimized workflow empowers
                you to seize fleeting arbitrage windows before they close.
              </p>
            </div>

            <div className="leverage__item leverage_risk">
              <h3 className="leverage__item-title">LBS Partners</h3>
              <div className="leverage__item-images">
                <div className="leverage__image">
                  <img src={Coinex} alt="Coinex" />
                </div>
                <div className="leverage__image">
                  <img src={Coinflex} alt="Coinflex" />
                </div>
                <div className="leverage__image">
                  <img src={Bitstamp} alt="Bitstamp" />
                </div>
                <div className="leverage__image">
                  <img src={BlockTech} alt="BlockTech" />
                </div>
                <div className="leverage__image">
                  <img src={Btcex} alt="Btcex" />
                </div>

                <div className="leverage__image">
                  <img src={Coinmetro} alt="Coinmetro" />
                </div>
                <div className="leverage__image">
                  <img src={Coinsbit} alt="Coinsbit" />
                </div>
                <div className="leverage__image">
                  <img src={Coinlist} alt="Coinlist" />
                </div>
                <div className="leverage__image">
                  <img src={Ecash} alt="Ecash" />
                </div>
                <div className="leverage__image">
                  <img src={Coinut} alt="Coinut" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="nft fade-in">
          <h2 className="nft__title">Blockchain-Powered NFT Investments</h2>
          <ul className="nft__list">
            <li className="nft__item">
              <h3 className="nft__item-title">NFT Arbitrage Opportunities</h3>
              <p className="nft__item-text">
                The burgeoning NFT market presents unique arbitrage
                opportunities, as rare and in-demand digital assets can trade at
                varying prices across different marketplaces. By carefully
                monitoring these price disparities, you can execute profitable
                trades and grow your crypto portfolio.
              </p>
            </li>
            <li className="nft__item">
              <h3 className="nft__item-title">Fractional NFT Ownership</h3>
              <p className="nft__item-text">
                Blockchain technology enables the fractionalization of
                high-value NFTs, allowing you to purchase partial ownership and
                participate in the price appreciation of these digital assets.
                This opens up new avenues for arbitrage and diversification
                within the NFT ecosystem.
              </p>
            </li>
            <li className="nft__item">
              <h3 className="nft__item-title">Smart Contract Automation</h3>
              <p className="nft__item-text">
                Leverage blockchain-based smart contracts to streamline your NFT
                arbitrage strategies, automating the execution of trades,
                managing royalties, and ensuring the secure transfer of digital
                assets between platforms and wallets.
              </p>
            </li>
            <li className="nft__item">
              <h3 className="nft__item-title">Decentralized Marketplaces</h3>
              <p className="nft__item-text">
                Explore the growing network of decentralized NFT marketplaces,
                which often exhibit price discrepancies compared to their
                centralized counterparts. By identifying and capitalizing on
                these disparities, you can unlock new arbitrage opportunities
                and diversify your crypto investment portfolio.
              </p>
            </li>
          </ul>
          <div className="nft__ai">
            <h2 className="nft__ai-title">AI-Driven Arbitrage Strategies</h2>
            <h3 className="nft__ai-subtitle">Market Analysis</h3>
            <p className="nft__ai-text">
              Utilize advanced AI algorithms to continuously monitor the
              cryptocurrency market, identify price movements, and detect
              arbitrage opportunities in real-time, far outpacing manual
              analysis.
            </p>
          </div>
        </section>

        <section className="arbitrage fade-in">
          <h2 className="arbitrage__title">
            Cross-Exchange Arbitrage Techniques
          </h2>
          <div className="arbitrage__content">
            <div className="arbitrage__item">
              <h3 className="arbitrage__item-title">Market Monitoring</h3>
              <p className="arbitrage__item-text">
                Utilize advanced AI algorithms to continuously monitor the
                cryptocurrency market, identify price movements, and detect
                arbitrage opportunities in real-time, far outpacing manual
                analysis.
              </p>
            </div>

            <div className="arbitrage__item">
              <h3 className="arbitrage__item-title">Order Execution</h3>
              <p className="arbitrage__item-text">
                Rapidly execute buy and sell orders on the respective exchanges
                to capitalize on price discrepancies before they disappear.
              </p>
            </div>

            <div className="arbitrage__item">
              <h3 className="arbitrage__item-title">Funds Transfer</h3>
              <p className="arbitrage__item-text">
                Seamlessly move funds between exchanges to ensure liquidity and
                enable the execution of subsequent arbitrage trades.
              </p>
            </div>
          </div>
        </section>

        <section className="team fade-in">
          <h2 className="team__title">Our Team</h2>
          <ul className="team__list">
            <li className="team__member">
              <div className="team__member-info">
                <div className="team__member-header">
                  <h3 className="team__member-name">Sophia Tan</h3>
                  <div className="team__member-role">
                    <span className="team__member-role-title">CEO</span>
                  </div>
                </div>
                <img
                  src={SophiaTan}
                  alt="Sophia Tan"
                  className="team__member-image"
                />
              </div>
              <p className="team__member-description">
                Sophia Tan is the founder and president of the Singapore Digital
                Innovation Association, which works with the Singapore
                government to promote development and innovation in digital
                industries. She is also CEO of BlockTech, a leading financial
                company in Singapore, building a global arbitrage platform and
                driving blockchain technology innovation.
              </p>
            </li>
            <li className="team__member">
              <div className="team__member-info">
                <div className="team__member-header">
                  <h3 className="team__member-name">Michael Johnson</h3>
                  <div className="team__member-role">
                    <span className="team__member-role-title">CTO</span>
                  </div>
                </div>
                <img
                  src={MichaelJohnson}
                  alt="Michael Johnson"
                  className="team__member-image"
                />
              </div>
              <p className="team__member-description">
                Michael Johnson is the co-founder and technical director of
                FutureTech, an American technology company. The company is
                attracting attention in the American technology industry by
                developing various projects and products using blockchain
                technology.
              </p>
            </li>
            <li className="team__member">
              <div className="team__member-info">
                <div className="team__member-header">
                  <h3 className="team__member-name">Li Wei</h3>
                  <div className="team__member-role">
                    <span className="team__member-role-title">CMO</span>
                  </div>
                </div>
                <img
                  src={Liwei}
                  alt="Li Wei"
                  className="team__member-image"
                  loading="lazy"
                />
              </div>
              <p className="team__member-description">
                Li Wei is a founding member of DigitalLink, a Chinese digital
                advertising company that holds a leading position in China's
                digital marketing market. At DigitalLink, Li Wei works with
                various companies in China to develop and implement digital
                advertising and marketing strategies, playing an important role
                in the company's growth and development.
              </p>
            </li>
            <li className="team__member">
              <div className="team__member-info">
                <div className="team__member-header">
                  <h3 className="team__member-name">Rajesh Patel</h3>
                  <div className="team__member-role">
                    <span className="team__member-role-title">CMO</span>
                  </div>
                </div>
                <img
                  src={RajeshPatel}
                  alt="Rajesh Patel"
                  className="team__member-image"
                  loading="lazy"
                />
              </div>
              <p className="team__member-description">
                Rajesh Patel is the Co-Founder and Chief Marketing Officer of
                DigiPierce, an Indian digital marketing company that is growing
                to be one of the leading players in digital marketing and
                advertising in India. Rajesh focuses on innovating and executing
                digital marketing strategies, making Digipeace a leader in the
                Indian digital marketing market.
              </p>
            </li>
          </ul>
        </section>

        <section className="conclusion fade-in">
          <h2 className="conclusion__title">Conclusion and Next Steps</h2>
          <p className="conclusion__subtitle">
            Unlock the Potential of Cryptocurrency Arbitrage
          </p>
          <p className="conclusion__text">
            In this comprehensive guide, we've explored the exciting world of
            cryptocurrency arbitrage, from leveraging multi-platform
            opportunities to integrating cutting-edge WEP3 technology and
            AI-driven strategies. By mastering these techniques, you can unlock
            new avenues for generating consistent returns and diversifying your
            crypto investment portfolio.
          </p>
        </section>
      </main>
    </>
  );
}

export default App;
